import { useSearchParams } from "react-router-dom";
import { ChartPanel } from "@/components/books/ChartPanel";
import { JournalsPanel } from "@/components/books/JournalsPanel";
import { LedgerPanel } from "@/components/books/LedgerPanel";
import { OverviewPanel } from "@/components/books/OverviewPanel";
import { RatesPanel } from "@/components/books/RatesPanel";
import { ReportsPanel } from "@/components/books/ReportsPanel";
import { TaxPanel } from "@/components/books/TaxPanel";
import { PageHeader } from "@/components/ui/page-header";
import { TabPanel, Tabs, pickTab, type TabItem } from "@/components/ui/tabs";

const TABS = ["overview", "reports", "ledger", "journals", "accounts", "rates", "tax"] as const;
type BooksTab = (typeof TABS)[number];
const TAB_ITEMS: TabItem<BooksTab>[] = [
  { id: "overview", label: "Overview" },
  { id: "reports", label: "Statements" },
  { id: "ledger", label: "Ledger" },
  { id: "journals", label: "Journals" },
  { id: "accounts", label: "Chart of accounts" },
  { id: "rates", label: "Exchange rates" },
  { id: "tax", label: "TDS and GST" },
];

export function BooksPage() {
  const [params, setParams] = useSearchParams();
  const tab = pickTab(params.get("tab"), TABS, "overview");
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Books"
        description="The double-entry books in rupees, derived from the invoices, payments, bills and transfers already recorded: the trial balance, profit and loss, balance sheet, every ledger, and the tax registers."
      />
      <div>
        <Tabs
          label="Books"
          items={TAB_ITEMS}
          value={tab}
          onChange={(next) => setParams(next === "overview" ? {} : { tab: next }, { replace: true })}
        />
        <TabPanel id={tab}>
          {tab === "overview" && <OverviewPanel />}
          {tab === "reports" && <ReportsPanel />}
          {tab === "ledger" && <LedgerPanel />}
          {tab === "journals" && <JournalsPanel />}
          {tab === "accounts" && <ChartPanel />}
          {tab === "rates" && <RatesPanel />}
          {tab === "tax" && <TaxPanel />}
        </TabPanel>
      </div>
    </div>
  );
}
